<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'內容编码'">
              <a-input  v-model="queryParam.contentCode" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'內容名称'">
              <a-input  v-model="queryParam.contentName" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="'內容類型'">
              <j-dict-select-tag  v-model="queryParam.contentType" dictCode="empzone_content_contentType" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('站点内容表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
           <a @click="publish(record)" v-if="record.status=='unpublished'">上架</a>
          <a @click="unpublish(record)" v-if="record.status=='published'">下架</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <empzone-content-modal ref="modalForm" @ok="modalFormOk"></empzone-content-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpzoneContentModal from './modules/EmpzoneContentModal'
  import { httpAction, getAction,postAction } from '@/api/manage'

  export default {
    name: 'EmpzoneContentList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpzoneContentModal
    },
    data () {
      return {
        description: '站点内容表管理页面',
        // 表头
        columns: [
          /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/

          {
            title:'内容編碼',
            align:"center",
            dataIndex: 'contentCode'
          },
          {
            title:'内容名称',
            align:"center",
            dataIndex: 'contentName'
          },
          {
            title:'内容类型',
            align:"center",
            dataIndex: 'contentType_dictText'
          },
          /*{
            title:'内容描述',
            align:"center",
            dataIndex: 'contentDesc'
          },*/
          {
            title:'状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'publishedTime',
            customRender:function (text,record) {
              if(record.status == 'published'){
                return !text?"":(text.length>19?text.substr(0,19):text)
              }else{
                return "";
              }
              // return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'建立人',
            align:"center",
            dataIndex: 'createrName'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/empzone/content/pagelist",
          delete: "/empzone/content/delete",
          publishUrl: "/empzone/content/publishstatus",
          deleteBatch: "/content/empzonecontent/batch",
          exportXlsUrl: "/content/export-xls",
          importExcelUrl: "content/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      publish(record){
        var that = this;
        //上架
        this.$confirm({
          title:'發佈',
          content:'是否確認發佈?',
          onOk: function(){
            getAction(that.url.publishUrl,{id:record.id,status:'published'}).then((res)=>{
              if(res.success){
                that.$message.success('操作成功');
                that.searchQuery()
                // that.onClearSelected();
              }else{
                that.$message.warn('操作失敗，請聯繫管理員')
              }
            });
          }
        });
      },
      unpublish(record){
        var that = this;
        //上架
        this.$confirm({
          title:'下架',
          content:'是否確認下架?',
          onOk: function(){
            getAction(that.url.publishUrl,{id:record.id,status:'unpublished'}).then((res)=>{
              if(res.success){
                that.$message.success('操作成功');
                that.searchQuery();
                // that.onClearSelected();
              }else{
                that.$message.warn('操作失敗，請聯繫管理員')
              }
            });
          }
        });
      },
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'siteId',text:'站点id',dictCode:''})
        fieldList.push({type:'string',value:'siteCode',text:'站点code',dictCode:''})
        fieldList.push({type:'string',value:'contentCode',text:'内容code',dictCode:''})
        fieldList.push({type:'string',value:'contentName',text:'内容名称',dictCode:''})
        fieldList.push({type:'string',value:'contentDesc',text:'内容描述',dictCode:''})
        fieldList.push({type:'string',value:'status',text:'状态(published:已发布；unpublished:未发布)',dictCode:''})
        fieldList.push({type:'date',value:'publishedTime',text:'发布时间'})
        fieldList.push({type:'string',value:'publishedUserId',text:'发布人id',dictCode:''})
        fieldList.push({type:'string',value:'fileUrl',text:'文件',dictCode:''})
        fieldList.push({type:'string',value:'contentType',text:'内容类型',dictCode:''})
        fieldList.push({type:'string',value:'contentUrl',text:'内容链接',dictCode:''})
        fieldList.push({type:'string',value:'contentManage',text:'内容管理单位',dictCode:''})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
